import type { ReactElement } from 'react';
import { HighlightText } from '@/components/common/HighlightText';
import { OPTION_DETAIL_SEPARATOR } from '@/utils/filters';
import { DrillName } from './DrillName';
import { StackedCellText } from './StackedCellText';

interface MemberIdentity {
  name: string;
  hrEmpId: string | null;
  mobile: string | null;
}

interface MemberNameCellProps {
  member: MemberIdentity;
  searchText?: string | undefined;
  nameLink?: ReactElement | undefined;
}

export function MemberNameCell({ member, searchText, nameLink }: MemberNameCellProps) {
  const detail = [member.hrEmpId, member.mobile].filter(Boolean).join(OPTION_DETAIL_SEPARATOR);
  const highlightedName = <HighlightText text={member.name} highlightedText={searchText} />;

  return (
    <StackedCellText
      primary={
        nameLink === undefined ? (
          highlightedName
        ) : (
          <DrillName
            value={member.name}
            label={`Open ${member.name}`}
            render={nameLink}
            highlightedValue={highlightedName}
          />
        )
      }
      primaryClassName="font-medium"
      secondary={detail && <HighlightText text={detail} highlightedText={searchText} />}
    />
  );
}
